import api from "../axiosIntercepture";

const unwrap = (response, fallbackMessage) => {
  if (response.data?.success) {
    return response.data.data;
  }
  const message =
    response.data?.message ||
    (typeof response.data?.data === "string" ? response.data.data : null) ||
    fallbackMessage;
  throw new Error(message);
};

export const listEnums = async (params = {}) => {
  const response = await api.get("enum/list", { params });
  return unwrap(response, "Failed to list enums");
};

export const getEnumById = async (id) => {
  const response = await api.get(`enum/${id}`);
  return unwrap(response, "Failed to load enum");
};

export const createEnumEntry = async (payload) => {
  const response = await api.post("enum", payload);
  return unwrap(response, "Failed to create enum");
};

export const updateEnumEntry = async (id, payload) => {
  const response = await api.patch(`enum/${id}`, payload);
  return unwrap(response, "Failed to update enum");
};

export const deleteEnumEntry = async (id) => {
  const response = await api.delete(`enum/${id}`);
  return unwrap(response, "Failed to delete enum");
};
